export const SLIDER_SETTINGS = {
    slidesToShow: 2.07,
    slidesToScroll: 1.07,
    infinite: false,
    arrow: false,
    dots: true,
    autoplay: false,
    useTransform: false
};
